import React from 'react';
import { Form } from 'react-bootstrap';
import { FaIdCard, FaUser, FaEnvelope, FaPhoneAlt, FaLock } from 'react-icons/fa';
import Select from '../../components/Select/Select';
import Switch from '../../components/Switch/Switch';
import './UserForm.css';

const INDIA_PHONE_REGEX = /^[6-9]\d{9}$/;

const UserForm = ({ state, inputHandler, params, canCreateMultiOrg, isMultiOrg, multiOrgToggleHandler }) => {
  const isPhoneInvalid = !!state.phone && !INDIA_PHONE_REGEX.test(state.phone);

  const phoneChangeHandler = (event) => {
    const digitsOnly = event.target.value.replace(/\D/g, '').slice(0, 10);
    inputHandler({ target: { name: 'phone', value: digitsOnly } });
  };

  return (
    <div className="user-form-section">
      <div className="user-form-section-title user-form-section-title-row">
        <span className="user-form-section-title-main">
          <span className="icon-badge"><FaIdCard /></span>
          <span>Personal Details</span>
        </span>
        {canCreateMultiOrg && !params.id && (
          <span className="user-form-multi-org-toggle">
            <Switch
              checked={isMultiOrg}
              id="multi-org-toggle"
              name="multi_org"
              value="1"
              onChange={multiOrgToggleHandler}
              label="Create across multiple organizations"
            />
          </span>
        )}
      </div>
      <div className="row">
        <div className="col-md-4 mb-3 user-form-field">
          <Form.Group>
            <Form.Label>
              Full name<i className="text-danger">*</i>
            </Form.Label>
            <div className="user-form-input-wrap">
              <span className="field-icon"><FaUser /></span>
              <Form.Control
                type="text"
                name="name"
                id="name"
                onChange={inputHandler}
                placeholder="Enter name"
                defaultValue={state.name}
                required
              />
            </div>
          </Form.Group>
        </div>
        <div className="col-md-4 mb-3 user-form-field">
          <Form.Group>
            <Form.Label>
              Email<i className="text-danger">*</i>
            </Form.Label>
            <div className="user-form-input-wrap">
              <span className="field-icon"><FaEnvelope /></span>
              <Form.Control
                type="email"
                name="email"
                id="email"
                onChange={inputHandler}
                placeholder="Enter email"
                defaultValue={state.email}
                required
                autoComplete='email'
              />
            </div>
          </Form.Group>
        </div>
        <div className="col-md-4 mb-3 user-form-field">
          <Form.Group>
            <Form.Label>
              Phone<i className="text-danger">*</i>
            </Form.Label>
            <div className="user-form-input-wrap">
              <span className="field-icon"><FaPhoneAlt /></span>
              <Form.Control
                type="tel"
                name="phone"
                id="phone"
                inputMode="numeric"
                maxLength={10}
                onChange={phoneChangeHandler}
                placeholder="Enter 10-digit mobile number"
                value={state.phone || ''}
                className={isPhoneInvalid ? 'is-invalid' : ''}
                required
              />
            </div>
            {isPhoneInvalid ? (
              <div className="user-form-error">Enter a valid 10-digit Indian mobile number</div>
            ) : (
              <div className="user-form-hint">10 digits, starting with 6-9</div>
            )}
          </Form.Group>
        </div>
        {isMultiOrg ? null : (
          <div className="col-md-4 mb-3 user-form-field">
            <Select
              label="Choose role"
              name="role_id"
              value={state.role_id}
              onChangeHandler={inputHandler}
              options={state.rolesData || []}
              placeholder="Choose Role"
              required={true}
              className="user-form-select"
            />
          </div>
        )}
        <div className="col-md-4 mb-3 user-form-field">
          {params.id ? null : (
            <Form.Group>
              <Form.Label>
                Password<i className="text-danger">*</i>
              </Form.Label>
              <div className="user-form-input-wrap">
                <span className="field-icon"><FaLock /></span>
                <Form.Control
                  type="password"
                  name="password"
                  id="password"
                  onChange={inputHandler}
                  placeholder="Enter password"
                  defaultValue={state.password}
                  required
                  autoComplete="current-password"
                />
              </div>
            </Form.Group>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserForm;
